/**
 * Module dependencies.
 */

import { Transaction } from 'app/hooks/requests/apps-crypto/use-get-apps-crypto-overview';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  item: Transaction;
};

/**
 * Export `OptionTransactionLabel` component.
 */

export function OptionTransactionLabel({ item }: Props): JSX.Element {
  return (
    <div className={'flex flex-row'}>
      <span className={'mr-2 text-xs font-semibold text-muted-foreground'}>{item.id}</span>

      <span>{`${item.amount} ${item.coin}`}</span>
    </div>
  );
}
